import * as angular from "angular";

export class OrganisationUserService {
    private readonly root: string;
    private readonly $http: any;

    constructor($http: any) {
        this.$http = $http;
        this.root = "/v2/organisation/user";
    }

    info(data: any): Promise<object> {
        return this.$http.get(this.root + "/" + data.id, data);
    }
}

angular
    .module("vcServices")
    .service("OrganisationUserService", OrganisationUserService);
